export enum PlatformSettingRoutes {
    GENERAL = 'general',
    RWA_CONDITIONS = 'rwa-conditions',
    RWA_INSIGHTS_REPORTS = 'rwa-insights-reports',
    ANALYTICS_BUILD = 'analytics-build'
}
